import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import {
  canPartnerOpenSettingsPath,
  getDefaultUserMeTenant
} from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute('/_protected/$tenantKey/settings')({
  // パートナーユーザーにはマスタを見せない（#5602）。自社の車両・ドライバーの一覧と詳細だけは開ける
  // （#6014）。URL を直接開いても、ほかのマスタ画面には入れない
  beforeLoad: ({ context: { auth }, location }) => {
    if (
      auth.user.type === USER_TYPE.PARTNER &&
      !canPartnerOpenSettingsPath(auth.user, location.pathname)
    ) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  meta: () => [{ title: MENU.MASTER_SETTINGS }]
})
